// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuOutlinedSvg from "@ant-design/icons-svg/es/asn/MenuOutlined";
import AntdIcon from '../components/AntdIcon';

var MenuOutlined = function MenuOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuOutlinedSvg
  }));
};

MenuOutlined.displayName = 'MenuOutlined';
export default React.forwardRef(MenuOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MenuOutlined.js
// module id = 1475
// module chunks = 0